// apps/vrw-cp - 集会一覧ページ
import React from "react";
import { GetServerSideProps } from "next";
import { ParsedUrlQuery } from "querystring";
import Typography from "@mui/material/Typography";

import { TimeRange } from "@vrw-guppy/react-vrw";

import MeeutpList from "@/components/MeeutpList";
import MainBox from "@/components/common/MainBox";
import OgpHead from "@/components/OgpHead";
import SearchForm from "@/components/SearchForm";
import { MeetupReadResponse, MeetupSearchRequest } from "@/lib/models/meetup";
import { listItemNoCache } from "@/lib/apiClient";

type ListItemProps = {
  items: MeetupReadResponse[];
  query: MeetupSearchRequest;
};

/**
 * クエリパラメータから集会検索クエリを生成する
 */
const buildMeetupQuery = (query: ParsedUrlQuery): MeetupSearchRequest => {
  const result: MeetupSearchRequest = {};
  Object.entries(query).forEach(([key, value]) => {
    if (typeof value === "string") {
      // 配列ではなく文字列のみを使用
      result[key] = value;
    }
  });
  if (!result.datetime) {
    // datetime が指定されていない場合はデフォルトの範囲を設定
    result.datetime = TimeRange.fromMode(new Date(), "WEEK_TEIKI")
      .toString("datetime")
      .replace("datetime=", "");
  }
  return result;
};

/**
 * 集会一覧データをSSRで取得し、キャッシュを完全に無効化する
 */
export const getServerSideProps: GetServerSideProps<ListItemProps> = async (
  context,
) => {
  // キャッシュを完全に無効化
  context.res.setHeader(
    "Cache-Control",
    "no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0"
  );
  context.res.setHeader("Pragma", "no-cache");
  context.res.setHeader("Expires", "0");
  
  const query = buildMeetupQuery(context.query);
  const items = await listItemNoCache({ type: "meetup", params: query });

  return {
    props: {
      items,
      query,
    },
  };
};

const App = ({ items, query }: ListItemProps) => {
  return (
    <>
      <OgpHead title="集会を検索する"></OgpHead>
      <MainBox
        sx={{
          border: "1px solid #eaeaea",
          borderRadius: "4px",
          backgroundColor: "background.paper",
        }}
      >
        <SearchForm
          type="meetup"
          query={query}
          seathKeys={[
            {
              label: "日時",
              value: "datetime",
              type: "datetime",
              enabled: false,
            },
            {
              label: "集会タイトル",
              value: "title",
              type: "string",
              enabled: false,
            },
            {
              label: "JOIN先",
              value: "user",
              type: "string",
              enabled: false,
            },
          ]}
        />
        <Typography variant="caption">
          注意: 時刻は国際標準時で検索してください。
        </Typography>
      </MainBox>
      <MainBox>
        <MeeutpList items={items || []} />
      </MainBox>
    </>
  );
};

export default App;
